import { RefObject, useEffect } from 'react';

/**
 * Used to fix a react-aria issue on touch devices.
 * https://github.com/adobe/react-spectrum/issues/1513
 */
export const usePreventTouchEnd = (ref: RefObject<Element | null>): void =>
  useEffect(() => {
    ref.current?.addEventListener(
      'touchend',
      (e) => {
        /**
         * The first condition is necessary to avoid the issue that a button with
         * type="submit" inside a <form> would not trigger the form submit
         * event on a device with touch input.
         *
         * The second condition is needed for thse buttons that are links
         * underneath and will have a href. If "touchend" is prevented, links
         * won't open by touch.
         *
         * Admittedly, this is an ugly patch, but given the react-spectrum
         * issue it seems necessary. If this hook grows any larger after
         * further bug reports and edge cases, we may want to reconsider
         * this approach.
         */
        if (
          (e.currentTarget as HTMLElement)?.getAttribute('type') !== 'submit' &&
          typeof (e.currentTarget as HTMLElement)?.getAttribute('href') !==
            'string'
        ) {
          e.preventDefault();
        }
      },
      { passive: false }
    );
  }, []);
